import { ErrorBoundaryComponent } from '@sharedUi/ErrorBoundary';
import classNames from 'classnames';

import styles from './DetachableBlock.module.scss';

export const DetachableBlock = ({ children, className }: { children: React.ReactNode; className?: string }) => {
  return (
    <ErrorBoundaryComponent>
      <div className={classNames(styles.WrapperPageBlock, className)}>{children}</div>
    </ErrorBoundaryComponent>
  );
};
